import { render } from "./new copy.vue?vue&type=template&id=2fdfb5a7&scoped=true"
import script from "./new copy.vue?vue&type=script&lang=js"
export * from "./new copy.vue?vue&type=script&lang=js"

import "./new copy.vue?vue&type=style&index=0&id=2fdfb5a7&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\agent-yuyooke\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdfb5a7"]])

export default __exports__